<template>
  <svg :width="width" :height="height">
    <path
      d="M3.776 4.693l-.662.757L0 2.725 3.114 0l.662.757-1.675 1.465h3.625c2.676 0 4.86 2.224 4.86 4.918a4.86 4.86 0 01-4.754 4.859L5.726 12H.158v-1.006h5.568A3.855 3.855 0 009.581 7.14c0-2.11-1.685-3.858-3.757-3.911l-.098-.001H2.101l1.675 1.465z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ReturnArrow",
  components: {},
  props: {
    color: {
      type: String,
      required: true
    },
    width: {
      type: String,
      required: true
    },
    height: {
      type: String,
      required: true
    }
  }
});
</script>
